import { ThemeMode } from '../../theme/guideTokens';
import { writeBlueLightLevel, writeBlueLightPreference, writeThemePreference } from '../../theme/ThemePreference';
import { clampBlueLightLevel } from '../../theme/blueLight';

export const SET_THEME_MODE = 'THEME_SET_MODE_ACTION';
export const SET_BLUE_LIGHT = 'THEME_SET_BLUE_LIGHT_ACTION';
export const SET_BLUE_LIGHT_LEVEL = 'THEME_SET_BLUE_LIGHT_LEVEL_ACTION';

export interface SetThemeModeAction {
  type: typeof SET_THEME_MODE;
  mode: ThemeMode;
  /** Usuario al que corresponde el modo (sub del perfil OIDC). */
  userId?: string;
}

export interface SetBlueLightAction {
  type: typeof SET_BLUE_LIGHT;
  enabled: boolean;
  userId?: string;
}

export interface SetBlueLightLevelAction {
  type: typeof SET_BLUE_LIGHT_LEVEL;
  /** Intensidad en porcentaje (10..100). */
  level: number;
  userId?: string;
}

export type ThemeKnownAction = SetThemeModeAction | SetBlueLightAction | SetBlueLightLevelAction;

/** Aplica un modo en el store sin persistirlo (p. ej. al cargar la preferencia guardada). */
export const setThemeMode = (mode: ThemeMode, userId?: string): SetThemeModeAction => ({
  type: SET_THEME_MODE,
  mode,
  userId,
});

/** Aplica la reducción de luz azul en el store sin persistirla. */
export const setBlueLight = (enabled: boolean, userId?: string): SetBlueLightAction => ({
  type: SET_BLUE_LIGHT,
  enabled,
  userId,
});

/** Aplica la intensidad del filtro en el store sin persistirla. */
export const setBlueLightLevel = (level: number, userId?: string): SetBlueLightLevelAction => ({
  type: SET_BLUE_LIGHT_LEVEL,
  level: clampBlueLightLevel(level),
  userId,
});

const currentUserId = (state: any): string | undefined => {
  const sub = state?.oidc?.user?.profile?.sub;
  return sub ? String(sub) : undefined;
};

/** Cambio elegido por el usuario: se guarda para ese usuario y se aplica. */
export const changeThemeMode =
  (mode: ThemeMode) =>
  (dispatch: (action: ThemeKnownAction) => void, getState: () => any): void => {
    const userId = currentUserId(getState());
    writeThemePreference(userId, mode);
    dispatch(setThemeMode(mode, userId));
  };

/** Reducción de luz azul elegida por el usuario: se guarda para ese usuario y se aplica. */
export const changeBlueLight =
  (enabled: boolean) =>
  (dispatch: (action: ThemeKnownAction) => void, getState: () => any): void => {
    const userId = currentUserId(getState());
    writeBlueLightPreference(userId, enabled);
    dispatch(setBlueLight(enabled, userId));
  };

/** Intensidad elegida por el usuario: se guarda para ese usuario y se aplica. */
export const changeBlueLightLevel =
  (level: number) =>
  (dispatch: (action: ThemeKnownAction) => void, getState: () => any): void => {
    const userId = currentUserId(getState());
    writeBlueLightLevel(userId, level);
    dispatch(setBlueLightLevel(level, userId));
  };
